import {
  FaCheckCircle,
  FaExclamationCircle,
  FaReply,
  FaTimesCircle,
} from "react-icons/fa";

export const getPaymentStatus = (status: string) => {
  let text: string = "";
  switch (status) {
    case "INITIATED":
      text = "Initiated";
      break;
    case "CANCELLED":
      text = "Cancelled";
      break;
    case "REVERTED":
      text = "Reverted";
      break;
    case "FAILED":
      text = "Failed";
      break;
    case "ACCEPTED":
    case "PROCESSED":
      text = "Processed";
      break;
    case "PENDING":
      text = "Pending";
      break;
    case "REFUNDED":
      text = "Refunded";
      break;
    default:
      break;
  }
  return text;
};

export const getPaymentStatusColor = (status: string) => {
  let text: string = "";
  switch (status) {
    case "INITIATED":
    case "PENDING":
      text = "color-orange";
      break;
    case "CANCELLED":
    case "FAILED":
      text = "color-red";
      break;
    case "REVERTED":
    case "REFUNDED":
      text = "color-blue";
      break;
    case "ACCEPTED":
    case "PROCESSED":
    case 'COMPLETED':
      text = "color-primary";
      break;
    default:
      break;
  }
  return text;
};

export const getPaymentStatusIcon = (status: string) => {
  let icon;
  switch (status) {
    case "PENDING":
    case "INITIATED":
    case "ACCEPTED":
    case "PROCESSED":
      icon = <FaCheckCircle />;
      break;
    case "CANCELLED":
      icon = <FaTimesCircle />;
      break;
    case "FAILED":
      icon = <FaExclamationCircle />;
      break;
    case "REVERTED":
    case "REFUNDED":
      icon = <FaReply />;
      break;
  }
  return icon;
};

export const roundAfterDecimal = (val: string | number) => {
  const num = Number(val);

  if (Number.isNaN(num)) return 0;

  const integerPart = Math.floor(num);
  const decimalPart = num - integerPart;

  return decimalPart >= 0.5 ? integerPart + 1 : integerPart;
};
